import { NotifyService } from '@/services/notify/notify_service'
import { AxiosResponse } from '@/types';
import { SearchParams } from '@/types/good_table_types'

export default class ActionSettingsNotifyService extends NotifyService {

  /**
   * アクションリスト設定依頼（全ユーザー）
   *
   * @aparam params
   */
  public notifyAll(param: SearchParams): Promise<AxiosResponse> {
    return this.getReq('/api/v1/action_settings_notify_all', param) as Promise<AxiosResponse>;
  }

  /**
   * アクションリスト設定依頼（指定ユーザー）
   *
   * @aparam params
   */
  public notifyTarget(userIds: number[]): Promise<AxiosResponse> {
    return this.getReq('/api/v1/action_settings_notify', {'userIds': userIds}) as Promise<AxiosResponse>;
  }

}

